// @flow
import React from 'react';
import { components } from '@peachjar/components';

const { TextInput } = components;

type Props = {
  handleDenialContact: () => void,
  organizationDenialContactInformation: string,
};

const OrganizationDenialContactInformation = ({
  handleDenialContact,
  organizationDenialContactInformation,
}: Props) => (
  <React.Fragment>
    <div className="d-flex flex-column">
      <p>
        Enter the contact information you would like community organizations to
        use for questions regarding flyer approval criteria.
      </p>
      <div style={{ paddingRight: '3rem' }}>
        <TextInput
          id="denialContactInput"
          label="Contact Information"
          multiline
          fullWidth
          value={organizationDenialContactInformation}
          onChange={handleDenialContact}
          data-testid="organizationDenialContactInformationTextInput"
        />
      </div>
      <p className="pt-2" style={{ color: '#707070' }}>
        E.g. For questions regarding flyer approval criteria, contact our flyer
        approval specialist at 555-123-4567 or approver@mydistrict.edu
      </p>
    </div>
  </React.Fragment>
);

export default OrganizationDenialContactInformation;



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/organization/components/OrganizationDenialContactInformation.jsx